import React from 'react';
import _ from 'lodash';
import { Flex, Box, Text } from 'rebass/styled-components';
import Imgix from 'shared/components/imgix';
import useStores from 'shared/hooks/use-stores';
import { shouldHideOrderEstimates } from 'shared/helpers/dispensaries';
import { getServiceEstimateForCart } from 'shared/helpers/order-estimates';

export default function DispensaryInfo({ dispensary }) {
  const { Cart } = useStores();
  const { isAfterHoursOrder } = Cart;

  const serviceType = Cart.order?.deliveryOption === 'delivery' ? 'delivery' : 'pickup';
  const estimate = getServiceEstimateForCart(Cart);
  const serviceEstimate = isAfterHoursOrder ? _.startCase(serviceType) : `Est. ${serviceType}`;
  const timeEstimate = `${serviceEstimate} | ${estimate}`;

  const shouldHideEstimates = shouldHideOrderEstimates(dispensary, Cart);

  return (
    <Flex mb='16px' flexWrap='nowrap' alignItems='flex-start'>
      <Box mr='18px' flexShrink={0}>
        <Imgix
          src={dispensary.logoImage}
          htmlAttributes={{ alt: `${dispensary.name} Logo` }}
          alt={`${dispensary.name} Logo`}
          width={65}
          height={53}
          fit='max'
        />
      </Box>
      <Box>
        <Text fontSize={17} fontWeight='bold' color='#606369' mt='6px' mb='8px'>
          {dispensary.name}
        </Text>
        {serviceType && !shouldHideEstimates && (
          <Text data-testid='confirmation-order-type' fontSize='12px' color='#606369' mt='6px'>
            {serviceType === 'delivery' && !dispensary.featureFlags?.hideDeliveryEstimate && timeEstimate}
            {serviceType === 'pickup' && timeEstimate}
          </Text>
        )}
      </Box>
    </Flex>
  );
}
